import { Link } from "react-router-dom";

/**
 * Cam kết của fundraising.vn trên trang chủ (27/10/2026, học từ khối
 * "Capable, and deliberately accountable" của FundingFactory). Khi site chưa
 * có tên tuổi, nói rõ công cụ làm gì và KHÔNG làm gì là cách tạo niềm tin.
 *
 * Mỗi câu phải đúng với hành vi thật của site. Đổi cách hoạt động (ví dụ thu
 * phí, gửi dữ liệu lên máy chủ) thì sửa khối này cùng lúc.
 */
const CAM_KET = [
  {
    ten: "Điểm nào cũng giải thích được",
    chu: "Mỗi điểm số tách theo nhóm tiêu chí, có trọng số cố định và lý do bằng lời. Không có con số nào bạn không mở ra xem được.",
  },
  {
    ten: "Chỉ ra việc làm tiếp theo",
    chu: "Kết quả luôn kèm một việc nên sửa trước và số điểm nó mang lại, thay vì chỉ cho bạn một con số để lo.",
  },
  {
    ten: "Tính trên máy bạn",
    chu: "Số liệu bạn nhập được tính ngay trong trình duyệt. Đăng nhập chỉ là tuỳ chọn, để đồng bộ Bản chuẩn bị giữa các thiết bị.",
  },
  {
    ten: "Dữ liệu quỹ có nguồn",
    chu: "Thông tin quỹ chỉ ghi điều nguồn chính thức nói rõ, kèm đường dẫn và ngày kiểm chứng. Điều quỹ không công bố thì để trống, không đoán.",
  },
  {
    ten: "Công cụ hỗ trợ, bạn quyết định",
    chu: "Kết quả để tham khảo, không phải tư vấn đầu tư hay pháp lý. Chọn quỹ nào, gửi gì và chốt vòng ra sao vẫn là việc của bạn.",
  },
  {
    ten: "Miễn phí, không cần tài khoản",
    chu: "Mọi công cụ dùng được ngay. Không thu phí để xem kết quả.",
  },
];

export default function CamKetMinhBach() {
  return (
    <section className="ckm section-space" aria-labelledby="ckm-tieu-de">
      <div className="ckm-dau">
        <p className="eyebrow">CÁCH CHÚNG TÔI LÀM</p>
        <h2 id="ckm-tieu-de">Công cụ tìm và chấm. <em>Bạn quyết định.</em></h2>
      </div>
      <ol className="ckm-luoi">
        {CAM_KET.map((c, i) => (
          <li key={c.ten}>
            <span className="ckm-so">{String(i + 1).padStart(2, "0")}</span>
            <h3>{c.ten}</h3>
            <p>{c.chu}</p>
          </li>
        ))}
      </ol>
      <p className="ckm-chan"><Link to="/gioi-thieu">Đọc thêm về cách fundraising.vn làm việc →</Link></p>
    </section>
  );
}
